import { API_ORIGIN } from './apiBase';

export const API_BASE = API_ORIGIN;
// Temporary kill switches. Remove each one when its corresponding surface is ready to return.
export const TEMP_DISABLE_FULL_ONLINE_SALES = false;
export const TEMP_ENABLE_FULL_ONLINE_SALES = false;
export const TEMP_DISABLE_SELLER_COMMISSIONS_MENU = false;

export const PHONE_PREFIXES = {
	venezuela: ['0414', '0424', '0412', '0416', '0426', '0422'],
	rd: ['809', '829', '849'],
	peru: ['9'],
	colombia: ['3'],
	bolivia: ['6','7']
};

export const PHONE_PLACEHOLDER: Record<typeof COUNTRIES[number], string> = {
	venezuela: 'XXX - XXXX',
	rd: 'XXX - XXXX',
	peru: 'XX - XXX - XXX',
	colombia: 'XX - XXX - XXXX',
	bolivia: 'XX - XXXXX'
};

export const PHONE_INTERPOLATION: Record<typeof COUNTRIES[number], Array<{ after: number; char: string }>> = {
	venezuela: [{ after: 3, char: '-' }],
	rd: [{ after: 3, char: '-' }],
	peru: [{ after: 2, char: '-' }, { after: 5, char: '-' }],
	colombia: [{ after: 2, char: '-' }, { after: 5, char: '-' }],
	bolivia: [{ after: 3, char: '-' }]
};

export const PREFIX_PLACEHOLDER: Record<typeof COUNTRIES[number], string> = {
	venezuela: 'XXXX',
	rd: 'XXX',
	peru: 'X',
	colombia: 'X',
	bolivia: 'X'
};

export const CARRIERS_BY_OPERATOR = {
	movistar: ['0414', '0424'],
	digitel: ['0412', '0422'],
	movilnet: ['0416', '0426'],
	altice: ['809', '829', '849'],
	claro: ['809', '829', '849'],
	viva: ['809', '829', '849'],
};

export const COUNTRIES = ['venezuela', 'rd', 'peru', 'colombia', 'bolivia'] as const;

export const COUNTRY_LABELS: Record<typeof COUNTRIES[number], string> = {
	venezuela: 'Venezuela',
	rd: 'RD',
	peru: 'Perú',
	colombia: 'Colombia',
	bolivia: 'Bolivia'
};

export const ACCESS_TYPES = ['atc', 'ata', 'postventa', 'admin', 'manager', 'tecnoplan', 'pagos', 'finanzas', 'marketing'] as const;

export const ACCESS_TYPE_LABELS: Record<typeof ACCESS_TYPES[number], string> = {
	atc: 'ATC',
	ata: 'ATA',
	postventa: 'Postventa',
	admin: 'Admin',
	manager: 'Manager',
	tecnoplan: 'TecnoPlan',
	pagos: 'Pagos',
	finanzas: 'Finanzas',
	marketing: 'Marketing'
};

export const LEVELS = ['level_1', 'level_2', 'level_3', 'level_4'] as const;

export const BANK_ACCOUNT_INTERPOLATION: Record<typeof COUNTRIES[number], Array<{ after: number; char: string }>> = {
	venezuela: [
		{ after: 4, char: '-' },
		{ after: 8, char: '-' },
		{ after: 12, char: '-' },
		{ after: 16, char: '-' },
	],
	rd: [
		{ after: 3, char: '-' },
		{ after: 6, char: '-' },
	],
	peru: [{ after: 3, char: '-' }],
	colombia: [
		{ after: 3, char: '-' },
		{ after: 6, char: '-' },
		{ after: 9, char: '-' },
	],
	bolivia: [
		{ after: 4, char: '-' },
		{ after: 8, char: '-' },
		{ after: 12, char: '-' },
	],
};

export const DOCUMENT_TYPE_OPTIONS: Record<typeof COUNTRIES[number], Array<{ label: string; value: string }>> = {
	venezuela: [
		{ label: 'RIF C.A. (J-)', value: 'rif' },
		{ label: 'Cédula Natural (V-)', value: 'cedula' },
		{ label: 'RIF F.P. (V-)', value: 'firma_personal' },
		{ label: 'Cédula Extranjera', value: 'extranjera' },
	],
	rd: [
		{ label: 'Cédula', value: 'cedula' },
		{ label: 'RNC', value: 'rnc' },
		{ label: 'Pasaporte', value: 'passport' },
	],
	colombia: [{ label: 'Cédula', value: 'cedula' }],
	bolivia: [
		{ label: 'Cédula', value: 'cedula' },
		{ label: 'NIT', value: 'nit' },
	],
	peru: [
		{ label: 'DNI', value: 'dni' },
		{ label: 'Ficha RUC', value: 'ruc' },
	],
};
